import React, {useEffect, useState} from "react";
import axios from "axios";
import {DataGrid, GridToolbar} from '@mui/x-data-grid';
import DatePicker from "react-datepicker";
import "react-datepicker/dist/react-datepicker.css";
import Swal from 'sweetalert2';
import {baseUrl, ipAddress, userLocation, userName} from '../Univ.js';
function EmpRooster(props) {
    const [startDate, setStartDate] = useState(null);
    const [endDate, setEndDate] = useState(null);
    const [empData, setEmpData] = useState([]);
    const [emp, setEmp] = useState('');
    const [shift, setShift] = useState('');
    const [viewShift, setviewShift] = useState([]);
    const [viewRoost, setviewRoost] = useState([]);
    const handleStartDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setStartDate(localDate);
    };
    const handleEndDateChange = (date) => {
        const localDate = new Date(date.getTime() - date.getTimezoneOffset() * 60000);
        setEndDate(localDate);
    };
    useEffect(() => {
        fetchempData();
        fetchShiftData();
        fetchRoostData();
    }, []);
    function fetchRoostData() {
        const url = `${baseUrl}create-rooster/`;
        axios.get(url)
            .then(response => {
                const transformedData = response.data.map(item => ({
                    ...item,
                    emp: item.emp?.employee || '',
                    emp__department: item.emp?.department?.department || '',
                    emp__designation: item.emp?.designation?.designation || '',
                    shift__shift_name: item.shift?.shift_name || ''
                }));
                setviewRoost(transformedData);
            })
            .catch(error => {
                console.log(error);
            });
    }
    function fetchempData() {
        const url = `${baseUrl}add-employee/`;
        axios.get(url)
            .then(response => {
                setEmpData(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    function fetchShiftData() {
        axios.get(`${baseUrl}create-shift/`)
            .then(response => {
                setviewShift(response.data);
            })
            .catch(error => {
                console.log(error);
            });
    }
    const handleUser = (event) => {
        setEmp(event.target.value);
    };
    const handleShift = (event) => {
        setShift(event.target.value);
    };
    const submitHandler = (e) => {
        e.preventDefault();
        const formData = new FormData();
        formData.append('from_date', startDate.toISOString().slice(0, 10));
        formData.append('to_date', endDate.toISOString().slice(0, 10));
        formData.append('emp', emp);
        formData.append('shift', shift);
        formData.append('addedby', userName);
        formData.append('ip_add', ipAddress);
        formData.append('location', userLocation);
        axios.post(baseUrl + 'create-rooster/', formData)
            .then(response => {
                if (response.status === 200 || response.status === 201) {
                    console.log('Form submitted successfully!', response.data);
                    Swal.fire({
                        title: 'Rooster List Create successfully',
                        icon: 'success',
                        timer: 2000,
                        showConfirmButton: false
                    });
                    setTimeout(() => {
                        window.location.href = '/emp-rooster';
                    }, 2000);
                }
            })
            .catch(error => {
                console.log(error);
                Swal.fire(
                    'Error!',
                    'Failed to Create. Please try again later.',
                    'error'
                );
            });
    };
    const handleDelete = (id) => {
        Swal.fire({
            title: 'Confirm',
            text: 'Are you sure you want to delete this?',
            icon: 'info',
            confirmButtonText: 'Continue',
            showCancelButton: true
        }).then((result) => {
            if (result.isConfirmed) {
                try {
                    axios.delete(baseUrl + 'delete-rooster/' + id + '/')
                        .then(function (response) {
                            Swal.fire('success', 'Data has been deleted');
                            window.location.reload();
                        });
                } catch (error) {
                    Swal.fire('error', 'Data has not been deleted');
                }
            } else {
                Swal.fire('error', 'Data has not been deleted');
            }
        });
    };
    const columns = [
        {field: 'from_date', headerName: 'From Date', width: 140},
        {field: 'to_date', headerName: 'To Date', width: 140},
        {field: 'emp', headerName: 'Employee Name', width: 150},
        {field: 'emp__department', headerName: 'Employee Dept', width: 150},
        {field: 'emp__designation', headerName: 'Employee Desg', width: 200},
        {field: 'shift__shift_name', headerName: 'Shift Time', width: 150},
        {
            field: 'delete', headerName: 'Action',
            renderCell: (params) => (
                <button onClick={() => handleDelete(params.row.id)} className="btn btn-danger btn-sm ms-1">
                    <i className="fa-solid fa-trash-can"></i>
                </button>
            ),
            width: 100
        },
    ];
    return (
        <section className="container mt-4">

            <div className="card shadow-sm border-0">

                <div
                    className="card-header text-center py-3"
                    style={{
                        color: "white",
                        backgroundColor: "#0dcaf0",
                    }}
                >
                    <h3 className="mb-0">
                        <i
                            className="fa-solid fa-calendar-days me-2"
                            aria-hidden="true"
                            style={{color: "red"}}
                        ></i>
                        Employee Rooster
                    </h3>
                </div>

                <div className="card-body p-4">

                    <form>

                        <div className="row">

                            {/* Date Range */}
                            <div className="col-md-6 mb-4">

                                <label
                                    htmlFor="user"
                                    className="form-label fw-semibold"
                                >
                                    Select Date Range
                                </label>

                                <div className="d-flex gap-3 flex-wrap">

                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleStartDateChange}
                                        selectsStart
                                        startDate={startDate}
                                        endDate={endDate}
                                        placeholderText="From Date"
                                        dateFormat="dd/MM/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        className="form-control"
                                    />

                                    <DatePicker
                                        selected={endDate}
                                        onChange={handleEndDateChange}
                                        selectsEnd
                                        startDate={startDate}
                                        endDate={endDate}
                                        minDate={startDate}
                                        placeholderText="To Date"
                                        dateFormat="dd/MM/yyyy"
                                        showMonthDropdown
                                        showYearDropdown
                                        className="form-control"
                                    />

                                </div>

                            </div>

                            {/* Employee */}
                            <div className="col-md-6 mb-4">

                                <label
                                    htmlFor="employee_id"
                                    className="form-label fw-semibold"
                                >
                                    Select Employee
                                </label>

                                <select
                                    name="employee_id"
                                    id="employee_id"
                                    value={emp}
                                    className="form-control"
                                    onChange={handleUser}
                                >
                                    <option value="">Select Employee</option>

                                    {empData.map((User, index) => (
                                        <option
                                            key={index}
                                            value={User.id}
                                        >
                                            {User.employee}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            {/* Shift */}
                            <div className="col-md-6 mb-4">

                                <label
                                    htmlFor="shift_name"
                                    className="form-label fw-semibold"
                                >
                                    Select Shift List
                                </label>

                                <select
                                    name="shift_name"
                                    id="shift_name"
                                    value={shift}
                                    className="form-control"
                                    onChange={handleShift}
                                >
                                    <option value="">Select Shift</option>

                                    {viewShift.map((shift, index) => (
                                        <option
                                            key={index}
                                            value={shift.id}
                                        >
                                            {shift.shift_name}
                                        </option>
                                    ))}
                                </select>

                            </div>

                            {/* Submit Button */}
                            <div className="col-md-12 text-center mt-3">

                                <button
                                    type="button"
                                    onClick={submitHandler}
                                    className="btn btn-success px-5 py-2"
                                >
                                    Submit
                                </button>

                            </div>

                        </div>

                    </form>

                </div>

            </div>

            {viewRoost.length > 0 && (
                <div style={{height: "100%", width: "100%"}}>

                    <DataGrid
                        className="mt-4"
                        sx={{
                            boxShadow: 4,
                            border: 4,
                            borderColor: "primary.light",
                            "& .MuiDataGrid-cell:hover": {
                                color: "primary.main",
                            },
                        }}
                        rows={viewRoost}
                        columns={columns}
                        pageSize={10}
                        slots={{
                            toolbar: GridToolbar,
                        }}
                        autoHeight
                    />

                </div>
            )}

        </section>
    );
}
export default EmpRooster;
